import { TemplateVersion } from './../../shared/dtos/template-version';
import { Template } from '@/shared/dtos/template';
import { Action, getModule, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { store } from '@/iti-core-vue/store';
import { itiHttpService, itiMessageService, ItiString } from '@/iti-core-vue';
import { API } from '@/shared';
import { LerCode } from '@/shared/dtos/ler-code';
import { Sector } from '@/shared/dtos/sector';
import { CnaeCode } from '@/shared/dtos/cnae-code';
import { Field } from '@/shared/dtos/field';
import { FieldType } from '@/shared/dtos/field-type';
import { UnitType } from '@/shared/dtos/unit-type';
import { CategoryFirstLevel } from '@/shared/dtos/category-first-level';
import { Values } from '@/shared/dtos/values';
import { FormattedCategory } from '@/shared/dtos/formatted-category';


@Module({
    namespaced: true,
    name: 'TemplatesModule',
    store,
    dynamic: true,
})

class TemplatesModule extends VuexModule {
    public templates: Template[] = [];
    public selectedTemplate: Template = new Template();
    public idSelectedTemplate: number = 0;
    public selectedTemplateVersion: TemplateVersion = new TemplateVersion();
    public templateFields: Field[] = [];
    public lerCodes: LerCode[] = [];
    public sectors: Sector[] = [];
    public cnaeCodes: CnaeCode[] = [];
    public categoriesFirstLevel: CategoryFirstLevel[] = [];
    public templateEditMode: boolean = false;
    public selectedField: Field = new Field();
    public fieldTypes: FieldType[] = [];
    public unitTypes: UnitType[] = [];
    public values: Values[] = [];
    public removeValues: Values[] = [];
    public idLastFieldCreated: number = 0;
    public formattedCategoriesList: FormattedCategory[] = [];

    @Mutation
    public setTemplates(templates: Template[]) {
        this.templates = templates;
    }

    @Action
    public async getTemplates(active: boolean | null | undefined) {
        if (active == null)
            active = false;
        const res = await itiHttpService.get(API.templates + '/GetAllTemplates?onlyActives=' + active);
        this.context.commit('setTemplates', res);
    }

    @Mutation
    public setTemplateById(template: Template) {
        this.selectedTemplate = template;
        // this.templateFields = template.fields;
    }

    @Mutation
    public setTemplateVersionById(templateVersion: TemplateVersion) {
        this.selectedTemplateVersion = templateVersion;
        this.templateFields = templateVersion.fields;
    }
    @Mutation
    public newTemplateVersion() {
        this.selectedTemplateVersion = new TemplateVersion();
        this.selectedTemplateVersion.fields = [];
        this.templateFields = this.selectedTemplateVersion.fields;
    }

    // @Action
    // public async createNewTemplateVersion(idTemplate: number, idToCopy: number | null) {
    //     if (idToCopy == null) {
    //         this.context.commit('newTemplateVersion');
    //     } else {
    //         const response = await itiHttpService.post(API.templateVersions + '/CreateTemplateVersion/templateId=' + idTemplate + '&templateVersionId=' + idToCopy, null, true, false, true);
    //     }
    // }

    @Mutation
    public newTemplate() {
        this.selectedTemplate = new Template();
        // this.selectedTemplate.fields = [];
        // this.templateFields = this.selectedTemplate.fields;
    }

    @Action
    public async getTemplateById(id: number) {
        if (id != null) {
            try {
                const response = await itiHttpService.get(API.templates + '/' + id, null, true, false, true);
                this.context.commit('setTemplateById', response);
            } catch (err) {
                return itiMessageService.TypeError;
            }
        }
        else {
            this.context.commit('newTemplate');
        }
    }

    @Action
    public async getTemplateVersionById(id: number) {
        if (id != null) {
            try {
                const response = await itiHttpService.get(API.templateVersions + '/' + id, null, true, false, true);
                this.context.commit('setTemplateVersionById', response);
            } catch (err) {
                return itiMessageService.TypeError;
            }
        }
        else {
            this.context.commit('newTemplateVersion');
        }
    }
    @Action
    public async saveTemplateVersion(templateVersion: TemplateVersion) {
        let res = null;
        this.templateFields.forEach((element, index) => {
            if (element.id == null) {
                this.templateFields[index].id = 0;
            }
        });
        if (templateVersion.id == null) {
            templateVersion.id = 0;
            res = await itiHttpService.post(API.templateVersions, templateVersion.toJson());
        } else {
            const templateVersionDB: TemplateVersion = new TemplateVersion(templateVersion);
            res = await itiHttpService.put(API.templateVersions, templateVersionDB.toJson());
        }
        let resTemplateVersion: TemplateVersion = res;
        if (resTemplateVersion.fields && resTemplateVersion.fields.length > 0) {
            this.context.commit('setIdLastFieldCreated', resTemplateVersion.fields[resTemplateVersion.fields.length - 1].id);
        }

        this.context.commit('setTemplateVersionById', res);

    }

    @Action
    public async saveTemplate(template: Template) {
        let res = null;

        if (template.id == null) {
            template.id = 0;
            res = await itiHttpService.post(API.templates, template.toJson());
        } else {
            const templateDB: Template = new Template(template);
            res = await itiHttpService.put(API.templates, templateDB.toJson());
        }

        this.context.commit('setTemplateById', res);
    }

    @Mutation
    public setIdLastFieldCreated(id: number) {
        this.idLastFieldCreated = id;
    }


    @Action
    public async deleteTemplate(template: Template) {
        if (template.id != null) {
            const url = API.templates + '/' + template.id;
            const res = await itiHttpService.delete(url, null);
        }
        this.context.dispatch('getTemplates');
    }

    @Mutation
    public setLerCodes(lerCodes: LerCode[]) {
        this.lerCodes = lerCodes;
    }

    @Action
    public async getLerCodes() {
        const res = await itiHttpService.get(API.lerCode);
        this.context.commit('setLerCodes', res);
    }

    @Mutation
    public setSectors(sectors: Sector[]) {
        this.sectors = sectors;
    }

    @Action
    public async getSectors() {
        const res = await itiHttpService.get(API.sector);
        this.context.commit('setSectors', res);
    }

    @Mutation
    public setCnaeCodes(cnaeCodes: CnaeCode[]) {
        this.cnaeCodes = cnaeCodes;
    }

    @Action
    public async getCnaeCodes() {
        const res = await itiHttpService.get(API.cnaeCode);
        this.context.commit('setCnaeCodes', res);
    }

    @Mutation
    public setCategories(categoriesFirstLevel: CategoryFirstLevel[]) {
        this.categoriesFirstLevel = categoriesFirstLevel;
    }

    @Action
    public async getCategories() {
        const res = await itiHttpService.get(API.categoryFirstLevel);
        this.context.commit('setCategories', res);
    }

    @Mutation
    public setFormattedCategories(formattedCategoriesList: FormattedCategory[]) {
        this.formattedCategoriesList = formattedCategoriesList;
    }

    @Action
    public async getFormattedCategories() {
        const res = await itiHttpService.get(API.formattedCategory);
        this.context.commit('setFormattedCategories', res);
    }

    @Mutation
    public setTemplateEditMode(editar: boolean) {
        this.templateEditMode = editar;
    }

    @Mutation
    public deleteFieldFromTemplate(field: Field) {
        this.templateFields.forEach((element, index) => {
            if (element == field) {
                this.templateFields.splice(index, 1);
                return;
            }
        });
    }

    @Action
    public async deleteTemplateVersion(version: TemplateVersion) {
        const url = ItiString.Format(API.templateVersionsDetail, version.id);
        const res = await itiHttpService.delete(url, null);
        this.context.commit('deleteVersionFromTemplate', res);
    }

    @Mutation
    public deleteVersionFromTemplate(version: TemplateVersion) {
        this.selectedTemplate.templateVersions.forEach((element, index) => {
            if (element == version) {
                this.selectedTemplate.templateVersions.splice(index, 1);
                return;
            }
        });
    }

    @Mutation
    public updateField(field: Field) {
        this.templateFields.forEach((element, index) => {
            if (element == field) {
                this.templateFields[index] = field;
                return;
            }
        });
    }

    @Mutation
    public newField() {
        this.selectedField = new Field();
    }

    @Mutation
    public setFieldToEdit(field: Field) {
        this.selectedField = field;
    }

    @Mutation
    public setFieldToEditById(idField: number) {
        this.templateFields.forEach((element, index) => {
            if (element.id == idField) {
                this.selectedField = element;
                return;
            }
        });
    }

    @Mutation
    public setFieldTypes(fieldTypes: FieldType[]) {
        this.fieldTypes = fieldTypes;
    }

    @Action
    public async getFieldTypes() {
        const res = await itiHttpService.get(API.fieldType);
        this.context.commit('setFieldTypes', res);
    }

    @Mutation
    public setUnitTypes(unitTypes: UnitType[]) {
        this.unitTypes = unitTypes;
    }

    @Action
    public async getUnitTypes() {
        const res = await itiHttpService.get(API.unitType);
        this.context.commit('setUnitTypes', res);
    }

    @Mutation
    public setFields(fields: Field[]) {
        this.templateFields = fields;
    }

    /* VALUES */

    @Action
    public async saveValues(values: Values) {
        let res = null;
        if (values.id == null) {
            res = await itiHttpService.post(API.values, values.toJson());
        } else {
            const ValuesDB: Values = new Values(values);
            res = await itiHttpService.put(API.values, ValuesDB.toJson());
        }
    }

    @Action
    public async deleteValues(values: Values) {
        if (values.id != null) {
            const url = API.values + '/' + values.id;
            const res = await itiHttpService.delete(url, null);
        }
    }

    @Action
    public async publishVersion(templateVersion: TemplateVersion) {
        const url = API.templateVersions + '/PublishVersion?templateVersionId=' + templateVersion.id;
        const res = await itiHttpService.post(url, null)
    }
    @Action
    public async activate(templateVersion: TemplateVersion) {
        const url = API.templateVersions + '/Activate?templateVersionId=' + templateVersion.id;
        const res = await itiHttpService.post(url, null)
    }

    @Action
    public async cloneVersion(templateVersion: TemplateVersion) {
        const url = API.templateVersions + '/CreateTemplateVersion?templateId=' + templateVersion.templateId + '&templateVersionId=' + templateVersion.id;
        const res = await itiHttpService.post(url, null)
    }
    @Action
    public async getValuesByFieldId(id: number) {
        let res: Values[] = [];
        let valuesByFieldId: Values[] = [];
        if (id != null) {
            try {
                res = await itiHttpService.get(API.values);
                res.forEach(element => {
                    if (element.fieldId == id) {
                        valuesByFieldId.push(element);
                    }
                });
            } catch (err) {
                return itiMessageService.TypeError;
            }
        }
        this.context.commit('setValuesByFieldId', valuesByFieldId);
    }

    @Mutation
    public setValuesByFieldId(values: Values[]) {
        if (values.length > 0) {
            this.values = values;
        } else {
            this.values = [];
        }
    }

    @Mutation
    public initializeValuesRange() {
        this.values.push(new Values());
        this.values.push(new Values());
    }

    @Mutation
    public addValueToValues(values: Values) {
        this.values.push(values);
    }

    @Mutation
    public resetValues() {
        this.values = [];
    }

    @Mutation
    public addValueToRemoveFromList(values: Values) {
        this.removeValues.push(values);
    }

    @Mutation
    public resetRemoveValues() {
        this.removeValues = [];
    }

}
export default getModule(TemplatesModule);